import { Molecule, wrap, Wrapper } from 'AppReact';
import styled from 'styled-components';
import { NoWrap, IconFromUrl } from 'atoms';

const template = styled.div`
  display: flex;
  align-items: center;
`;

export default Molecule({
  template,
  atoms: [
    {
      component: wrap(IconFromUrl, Wrapper(styled.div`margin-right: 5px`)),
      name: 'Icon',
      displayValue: ({ icon }) => icon,
      renderIf: ({ icon }) => !!icon
    },
    {
      component: NoWrap,
      name: 'Text',
      displayValue: ({ text }) => text,
    },
  ],
})